
@if (loading() && loadingTemplate(); as loadingTemplate) {
  <ng-container *ngTemplateOutlet="loadingTemplate" />
} @else if (itemsCount() !== null) {
  @if (itemsCount()) {
    <div class="content-list">
      @for (contentList of contentLists(); track contentList) {
        @if (contentList.items()?.length) {
          <div class="content-list-header">
            @if (contentList.headerTemplate(); as headerTemplate) {
              <ng-container *ngTemplateOutlet="headerTemplate" />
            }
          </div>
          <div class="content-list-items" [style.background-color]="contentList.backgroundColor()">
            @for (item of contentList.items(); track item) {
              @if (contentList.itemTemplate(); as itemTemplate) {
                <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }" />
              }
            }
          </div>
        }
      }
      @if (footerTemplate(); as footerTemplate) {
        <div class="content-list-footer">
          <ng-container *ngTemplateOutlet="footerTemplate" />
        </div>
      }
    </div>
  } @else {
    @if (emptyTemplate(); as emptyTemplate) {
      <ng-container *ngTemplateOutlet="emptyTemplate"></ng-container>
    }
  }
} @else {
    @if (placeholderTemplate(); as placeholderTemplate) {
      <ng-container *ngTemplateOutlet="placeholderTemplate"></ng-container>
    }
}
